var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout app-layout-ecatalogue"},[_c('e-catalogue-header',{attrs:{"open":_vm.noop,"openOrder":_vm.goOrderHistory,"route-prefix":_vm.routePrefix,"fixed-store":true}}),_c('b-container',{attrs:{"fluid":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }